// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"55ac2e07","425":"fab32ba9","510":"e0ea0e37","532":"414d80e7","633":"56ad3899","634":"a3ffc04e","922":"d2567437","937":"e949876f","972":"1ccb3a67"}[chunkId] + ".chunk.js";
};